import { createEvent, createStore } from 'effector'

export const openPenaltiesDrawer = createEvent()
export const closePenaltiesDrawer = createEvent()

export const $isPenaltiesDrawerOpen = createStore<boolean>(false)
  .on(openPenaltiesDrawer, () => true)
  .on(closePenaltiesDrawer, () => false)
